import { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useOrganizationContext } from '../../organization.context';
import { EXCLUDE, BUCKETS, readRules } from './constants';
import RulesSheet from './rules-sheet';

export default function SearchRankingCard() {
  const { organization } = useOrganizationContext();
  const [open, setOpen] = useState(false);

  const rules = readRules(organization);
  const enabled = rules.filter(rule => rule.enabled !== false);
  const excluding = enabled.filter(rule => BUCKETS.some(bucket => rule[bucket] === EXCLUDE));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Search ranking rules</CardTitle>
        <CardDescription>
          Reorder or hide this organization&apos;s search results on top of text relevance. Changes
          take effect on the next search — no reindex.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm">
          {rules.length === 0
            ? 'No rules — results are ordered purely by text relevance.'
            : `${rules.length} rule${rules.length === 1 ? '' : 's'} · ${enabled.length} enabled`}
        </p>

        {excluding.length > 0 && (
          <p className="flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 p-2 text-sm text-amber-700">
            <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0" />
            {excluding.length} enabled rule{excluding.length === 1 ? '' : 's'} remove results from
            search entirely.
          </p>
        )}

        <Button onClick={() => setOpen(true)}>Manage rules</Button>
      </CardContent>

      {/* Mounted only while open so the draft array is dropped on close. */}
      {open && <RulesSheet open={open} onOpenChange={setOpen} />}
    </Card>
  );
}
